export default __webpack_public_path__ + "static/ceinture.cover-9a218872c8ce2973e6817123a1989f1d.jpg";